<template>
  <div>
    <BasicModal
      :isShowModal="isOpenModalNap"
      @close-modal="handleToggleModalNap"
      title="NAP 자문서 작성 111"
      disabledFooter
      v-if="data"
    >
      <div class="bodyContent">
        <div
          class="matchingItemImages popupViewProfile"
          style="justify-content: start"
        >
          <CorpInfoCard
            v-if="data.requester && data.requester.roleName == $role.CORP"
            :data="data.requester"
            hideHomepage
            hideBorder
          />
          <UserInfoCard
            v-else-if="data.requester && data.requester.roleName == $role.USER"
            :data="data.requester"
            hideBorder
          />
          <div class="matchingBtnInside">
            <img
              src="@/assets/svg/next.svg"
              alt=""
              height="18px"
              width="18px"
            />
          </div>

          <CorpInfoCard
            v-if="data.requested && data.requested.roleName == $role.CORP"
            :data="data.requested"
            nameColor="#502423"
            hideHomepage
            hideBorder
          />
          <UserInfoCard
            v-else-if="data.requested && data.requested.roleName == $role.USER"
            :data="data.requested"
            nameColor="#502423"
            hideBorder
          />
        </div>

        <h3 class="matchingHeadLine">신청서</h3>
        <ValidationObserver tag="form" v-slot="{ handleSubmit }" class="aRow5">
          <form
            class="infoBoxForm"
            @submit.prevent="handleSubmit(onClickSubmitForm)"
          >
            <div style="margin-bottom: 50px;">
              <LabelInput label="신청 대상 기업" :value="data.requested.name" />
              <LabelInput
                label="매칭신청 사유"
                type="textarea"
                :value="data.napApplication"
              />

              <div class="line" style="margin-top: 20px;"></div>
              <h3 class="matchingHeadLine">연락처 정보</h3>
              <LabelInput label="신청자 이름" :value="data.requester.name" />
              <LabelInput label="이메일 주소" :value="data.requester.email" />
              <LabelInput
                label="전화번호"
                :value="data.requester.phoneNumber"
              />
              <div class="line" style="margin-top: 20px;"></div>
              <h3 class="matchingHeadLine">NAP 자문 요청</h3>
              <TextAreaInputField
                label="NAP 자문 요청 사항"
                v-model="data.question"
              />
              <div class="line" style="margin-top: 20px;"></div>
              <h3 class="matchingHeadLine matchingHeadLine--green">
                NAP 자문 답변
              </h3>

              <ValidationProvider
                name="NAP 자문 답변"
                rules="required"
                v-slot="{ errors }"
              >
                <TextAreaInputField
                  label="NAP 자문 답변"
                  v-model="form.answer"
                  :errors="errors"
                />
              </ValidationProvider>
            </div>

            <div class="modal-action">
              <MainButton
                btnText="자문서 전송"
                color="green"
                type="submit"
                :disabled="disabledSubmit"
                v-if="data.status == napStatus.PENDING"
              />
              <MainButton
                btnText="닫기"
                color="gray"
                @click="handleToggleModalNap"
                v-else
              />
            </div>
          </form>
        </ValidationObserver>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import BasicModal from "@/components/modal/BasicModal.vue";
import TextAreaInputField from "@/components/formControl/TextAreaInputField.vue";
import MainButton from "@/components/button/MainButton.vue";
import { napStatus } from "@/data/constances";
import LabelInput from "@/components/formControl/LabelInput.vue";
import CorpInfoCard from "@/components/items/CorpInfoCard.vue";
import UserInfoCard from "@/components/items/UserInfoCard.vue";
import { companyType } from "@/utils/corpUtil";

export default {
  name: "NapWritPopup",
  components: {
    BasicModal,
    ValidationObserver,
    ValidationProvider,
    TextAreaInputField,
    MainButton,
    LabelInput,
    CorpInfoCard,
    UserInfoCard,
  },
  props: ["data", "isOpenModalNap", "handleToggleModalNap"],
  computed: {
    companyType() {
      return this.lodash.find(companyType, (o) => {
        return o.value == this.data.companyType;
      })?.text;
    },
  },
  data() {
    return {
      disabledSubmit: false,
      testInfo: this.data.requesterId + " ",
      application: this.data.napApplication,
      form: {
        requestId: this.data.idx,
        status: "APPROVED",
        answer: this.data.answer,
      },
      napStatus: napStatus,
    };
  },

  methods: {
    onClickSubmitForm() {
      var that = this;
      this.disabledSubmit = true;
      this.$emit("onReply", this.form);
      setTimeout(() => {
        that.disabledSubmit = false;
      }, 3000);
    },
  },

  watch: {
    data: {
      handler(val) {
        this.application = val.napApplication;
        this.form.requestId = val.idx;
        this.form.answer = val.answer;
      },
      deep: true,
    },
  },
};
</script>
